import { InjectionToken } from '@angular/core';

/**
 * The leading dimension of the dashboard's left drill chart.
 *
 * - `productGroup` (default): the product drill — a toggle between the separate
 *   Produktgruppen chain (Produktgruppe → Artikel) and the Hauptgruppen
 *   hierarchy (Hauptgruppe → Untergruppe → Unter-Untergruppe → Artikel).
 * - `salesRepresentative`: a Vertreter dashboard — for customers without a
 *   product hierarchy (e.g. Softline). Drills Vertreter → Kunde.
 */
export type SalesStatisticsLeadDimension = 'productGroup' | 'salesRepresentative';

export interface SalesStatisticsConfig {
  leadDimension: SalesStatisticsLeadDimension;
}

export const SALES_STATISTICS_DEFAULT_CONFIG: SalesStatisticsConfig = {
  leadDimension: 'productGroup',
};

/**
 * Per-customer configuration for the sales-statistics module. Provide it in the
 * customer config (`apps/softapps/configs/<customer>/…/customer-config.ts`) to
 * override the default. Consumers should inject it as optional and fall back to
 * {@link SALES_STATISTICS_DEFAULT_CONFIG}.
 */
export const SOFTLINE_CONFIG_SALES_STATISTICS =
  new InjectionToken<SalesStatisticsConfig>('SOFTLINE_CONFIG_SALES_STATISTICS');
